var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo } from 'react';
import { Spin, message } from 'antd';
import { Button, Select } from 'ui/styled';
import { useMembersForNicLazyQuery } from 'apollo/queries/NIC/MEMBERS_FOR_NIC';
import { getNodes } from 'utils/paginationHelper';
import { useCallStore } from 'stores/nic/stores/callStore';
import { useNicService } from 'stores/nic/useNicService';
import { selectIsSessionActive, useNicStore } from 'stores/nic/stores/nicStore';
import { ChooseSkillLabel, StyledMembers, StyledSkills } from './styled';
import { MemberItem } from './MemberItem';
export var MembersList = function (_a) {
    var agentSkills = _a.agentSkills, skill = _a.skill, setSkill = _a.setSkill, dialNumber = _a.dialNumber, disabled = _a.disabled, callIndex = _a.callIndex;
    var memberToCall = useCallStore(function (state) { var _a; return (_a = state.calls[callIndex]) === null || _a === void 0 ? void 0 : _a.memberInfo; });
    var isSessionActive = useNicStore(selectIsSessionActive);
    var setCalls = useCallStore(function (state) { return state.setCalls; });
    var setMemberToCall = function (member) { return setCalls({ index: callIndex, memberInfo: member }); };
    var dialOutboundCall = useNicService().dialOutboundCall;
    var options = __spreadArray([], agentSkills, true).sort(function (a, b) { return a.skillName.localeCompare(b.skillName); })
        .map(function (item) { return ({
        label: item.skillName,
        value: item.skillId
    }); });
    var _b = useMembersForNicLazyQuery({
        variables: {
            filters: {
                phone_search: dialNumber
            }
        }
    }), loadUsers = _b[0], _c = _b[1], loading = _c.loading, data = _c.data;
    var members = useMemo(function () { return getNodes(['members'])(data); }, [data]);
    useEffect(function () {
        if (!isSessionActive || disabled)
            return;
        loadUsers();
    }, [dialNumber, isSessionActive, disabled, loadUsers]);
    var handleOutboundCall = useCallback(function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (phoneNumber) {
            var numberToDial, contactDetails;
            var _a;
            if (phoneNumber === void 0) { phoneNumber = null; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        numberToDial = phoneNumber || ((_a = memberToCall === null || memberToCall === void 0 ? void 0 : memberToCall.preferred_phone_number) === null || _a === void 0 ? void 0 : _a.trim());
                        if (!numberToDial) {
                            message.error('The phone number is not valid');
                            return [2 /*return*/];
                        }
                        console.log('=== DIALING OUTBOUND CALL ===');
                        contactDetails = { skillId: skill, phoneNumber: numberToDial };
                        return [4 /*yield*/, dialOutboundCall(contactDetails)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }, [memberToCall, skill, dialOutboundCall]);
    if (loading || disabled)
        return _jsx(Spin, { style: { padding: 16, width: '100%' } });
    if (memberToCall)
        return (_jsxs(_Fragment, { children: [_jsx(StyledMembers, { children: _jsx(MemberItem, { item: memberToCall, memberToCall: memberToCall, setMemberToCall: setMemberToCall, hasDivider: false }) }), _jsx(Button, { style: { margin: '8px 16px' }, onClick: function () { return setMemberToCall(null); }, children: "Choose Again" }), _jsx(ChooseSkillLabel, { children: "Choose skill" }), _jsx(StyledSkills, { children: _jsx(Select, { placeholder: "Choose skill", onChange: function (skillId) { return setSkill(skillId); }, value: skill, options: options }) }), skill ? (_jsx(Button, { style: { margin: '8px 0' }, onClick: function () { return handleOutboundCall(); }, disabled: !isSessionActive, children: "Dial" })) : null] }));
    if (members.length)
        return (_jsx(StyledMembers, { children: members.map(function (item, index) { return (_jsx(MemberItem, { item: item, memberToCall: memberToCall, setMemberToCall: setMemberToCall, hasDivider: index !== members.length - 1 }, item.id)); }) }));
    if (!loading) {
        return (_jsxs("div", { children: [_jsx("p", { children: "No members found. Make a direct call?" }), _jsx(ChooseSkillLabel, { children: "Select skill" }), _jsx(StyledSkills, { children: _jsx(Select, { placeholder: "Choose skill", onChange: function (skillId) { return setSkill(skillId); }, value: skill, options: options }) }), skill ? (_jsxs(Button, { style: { margin: '8px 0' }, onClick: function () { return handleOutboundCall(dialNumber); }, disabled: !isSessionActive, children: ["Call ", dialNumber] })) : null] }));
    }
    return null;
};
